import { clientFetch } from "./clientFetch";

export const AbsenceService = {
  getAbsences: (uidCompany: string, uidCalendar: string, dateMin?: string, dateMax?: string) =>
    clientFetch("/v2/calendar/absence/get-absences", "POST", null, {
      body: { company: uidCompany, uidCalendar, dateMin, dateMax },
    }),
  createAbsence: (payload: Record<string, unknown>, key: string) =>
    clientFetch("/v2/calendar/absence/create-absence", "POST", key, { body: payload }),
  updateAbsence: (payload: Record<string, unknown>, key: string) =>
    clientFetch("/v2/calendar/absence/update-absence", "POST", key, { body: payload }),
  deleteAbsence: (payload: Record<string, unknown>, key: string) =>
    clientFetch("/v2/calendar/absence/delete-absence", "POST", key, { body: payload }),
};
